import OfferTypeList from './OfferTypeList';

export default {
    list: 	OfferTypeList
};
